import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button as MuiButton, CircularProgress } from '@mui/material';
import toast from 'react-hot-toast';
import { submitForm } from '../../../store/slices/ideaSubmissionSlice';
import { SubmissionCompleted } from '../SubmissionCompleted/SubmissionCompleted';
import FormContainer from '../../../common/FormContainer/FormContainer';
import Button from '../../../common/Button/Button';
import './ReviewSubmitStep.css';
import ReCAPTCHA from 'react-google-recaptcha';
import { useState } from 'react';

export function ReviewSubmitStep({ onBack }) {
  const dispatch = useDispatch();
  const { theme, ideaAnswers, submitDetails } = useSelector(
    (state) => state.ideaSubmission
  );
  const { isSubmitting, submitSuccess, submitError } = useSelector(
    (state) => state.ideaSubmission
  );
  const { submissionData } = useSelector(
    (state) => state.ideaSubmission.auth
  );
  

  const [captchaToken, setCaptchaToken] = useState(null);

  const renderRow = (label, value) => (
    <div className="review-row">
      <div className="review-key">{label}</div>
      <div className="review-value">
        {value || <span className="muted">Not provided</span>}
      </div>
    </div>
  );

  const renderLongText = (label, value) => (
    <div className="review-long">
      <div className="review-key">{label}</div>
      <div className="review-long-value">
        {value || <span className="muted">Not provided</span>}
      </div>
    </div>
  );

const handleSubmit = async () => {
  if (!captchaToken) return;

  try {
    await dispatch(
      submitForm({ captchaToken })
    ).unwrap();

    toast.success('Submission successful! Thank you for your contribution.');
  } catch (error) {
    toast.error('Submission failed. Please try again.');
    console.error(error);
  }
};



  if (submitSuccess) {
    return (
      <SubmissionCompleted
        mode="submission_successful"
        submissionData={submissionData}
      />
    );
  }

  return (
    <div className="review-submit-step">
      <FormContainer>
        {/* Back */}
        <MuiButton onClick={onBack} sx={{ mb: 2 }}>
          Back
        </MuiButton>

        <h2 className="review-title">Review Your Submission</h2>

        {/* ================= THEME ================= */}
        <div className="review-card highlight">
          <h3 className="review-card-title">Selected Theme</h3>
          <div className="theme-pill">
            {theme.customTheme || theme.themeTitle}
          </div>
        </div>

        {/* ================= IDEA ================= */}
        <div className="review-card">
          <h3 className="review-card-title">Your Idea</h3>

          {renderLongText('Problem', ideaAnswers.problem)}
          {renderLongText('Who is affected', ideaAnswers.affectedWho)}
          {renderLongText(
            'Why this problem exists',
            ideaAnswers.why
          )}
          {renderLongText(
            'Proposed solution',
            ideaAnswers.solution
          )}
        </div>

        {/* ================= DETAILS ================= */}
        <div className="review-card">
          <h3 className="review-card-title">Your Details</h3>

          {renderRow('Name', submitDetails.name)}
          {renderRow('Gender', submitDetails.gender)}
          {renderRow('Phone', submitDetails.phone)}
          {renderRow('District', submitDetails.district)}
          {renderRow('Grade Group', submitDetails.gradeGroup)}
          {renderRow('Submitting as Team', submitDetails.isTeam)}

          {submitDetails.isTeam === 'Yes' &&
            submitDetails.teamMembers?.length > 0 && (
              <div className="team-list">
                <div className="review-key">Team Members</div>
                <div className="team-chips">
                  {submitDetails.teamMembers.map((m) => (
                    <span key={m} className="team-chip">
                      {m}
                    </span>
                  ))}
                </div>
              </div>
            )}
        </div>

        {/* ================= ACTIONS ================= */}
        <div className="submit-btn-wrapper">
          <ReCAPTCHA
            sitekey={process.env.REACT_APP_RECAPTCHA_V2_SITE_KEY}
            onChange={(token) => setCaptchaToken(token)}
            onExpired={() => setCaptchaToken(null)}
          />

{ !captchaToken && (
  <div
    style={{
      color: '#d32f2f',
      fontSize: '14px',
      marginBottom: '8px',
      textAlign: 'center'
    }}
  >
    Please verify that you are human by completing the CAPTCHA.
  </div>
)}


          <Button
            size="large"
            onClick={handleSubmit}
            disabled={isSubmitting || !captchaToken}
            className='submit-btn'
          >
            {isSubmitting ? (
              <>
                <CircularProgress size={20} color="inherit" style={{ marginRight: '8px' }} />
                Submitting...
              </>
            ) : (
              'Submit Idea'
            )}
          </Button>

          {submitError && (
            <div className="error-message" style={{ marginTop: '1rem', color: '#e53e3e' }}>
              {submitError}
            </div>
          )}
        </div>
      </FormContainer>
    </div>
  );
}
